import { useMemo } from "react";

import { IAccordionSelection } from "./types";

const NO_DATA: IAccordionSummaryDisplayData[] = [];

interface IAccordionSummaryDisplayData {
	display: IAccordionSelection;
	count: number;
}

export const useAccordionSelectionDisplay = (
	options: IAccordionSelection[],
	selected: string[]
) => {
	return useMemo(() => {
		if (!options.length) return NO_DATA;
		const uniqueslections = Array.from(new Set<string>(selected));

		return uniqueslections.reduce<IAccordionSummaryDisplayData[]>((data, select) => {
			const display = options.find((opt) => opt.id === select);

			if (!display) return data;

			return [
				...data,
				{
					display,
					count: selected.filter((s) => s === select).length,
				},
			];
		}, []);
	}, [options, selected]);
};
